import React from "react";

import ContactsActions from "../../../../../contacts/components/ContactsActions";
import ContactsModals from "../../../../../contacts/components/ContactsModals";
import ContactsTableSection from "../../../../../contacts/components/ContactsTableSection";
import useContactsForForms from "../../../../../contacts/hooks/useContactsForForms";

export default function Contacts({ data, questionKey }) {
  const { permissions, menuList, visibleData, handlers, isLoading } = useContactsForForms({
    data,
    questionKey,
  });

  return (
    <div className="flex h-full flex-col gap-6 px-4 py-2">
      <ContactsActions permissions={permissions} menuList={menuList} />
      <ContactsTableSection
        visibleData={visibleData}
        permissions={permissions}
        editHandler={handlers.openEditModal}
        deleteHandler={handlers.openDeleteModal}
        loading={isLoading}
        maxHeight={false}
      />
      <ContactsModals
        mode={handlers.mode}
        modalSize={handlers.modalSize}
        additionalDetails={handlers.additionalDetails}
        openModal={handlers.openModal}
        handleCloseModal={handlers.handleCloseModal}
        showFailureModal={handlers.showFailureModal}
        handleFailure={handlers.handleFailure}
      />
    </div>
  );
}
